// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5D1D1fgN","overlay":"_5D2217os","icon":"_5D3gQGzd"};